module.exports = __webpack_public_path__ + "img/Terraced_House.4e4bb953.svg";